import cx from 'classnames';
import PropTypes from 'prop-types';

import Component from './component';
import * as style from './bubble.module.scss';

const Bubble = ({ as, className, ...props }) => {
  return (
    <Component as={as} className={cx(style.bubble, className)} {...props} />
  );
};

Bubble.propTypes = {
  as: PropTypes.node,
  className: PropTypes.string,
};

Bubble.defaultProps = {
  as: 'span',
};

export default Bubble;
